export default __webpack_public_path__ + "static/media/tiger-1.365a8419.png";